import { render } from "./create-territory.vue?vue&type=template&id=4e0a7dfe"
import script from "./create-territory.vue?vue&type=script&lang=js"
export * from "./create-territory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__